import { render } from "./DayOperatingHours.vue?vue&type=template&id=36bdef43&scoped=true"
import script from "./DayOperatingHours.vue?vue&type=script&lang=js"
export * from "./DayOperatingHours.vue?vue&type=script&lang=js"

import "./DayOperatingHours.vue?vue&type=style&index=0&id=36bdef43&lang=scss&scoped=true"

import exportComponent from "/home/scotty/git/beamy/monolith/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36bdef43"]])

export default __exports__